// 用于存放关于自定义字段的一些工具/可复用函数
import { i18nSymbol } from '@/i18n';
import { injectService } from '@/inversify.config';
export function getCustomFieldUpdatedMessage({ field, action }) {
    const { type, auto_edit_field_value, auto_edit_field_value_scope, has_delete_layer_center_task } = field;
    const i18n = injectService(i18nSymbol);
    let message = action === 'EDIT' ? i18n.t('fields.editCustomFieldOk') : i18n.t('fields.addCustomFieldOk');
    if (type === 'OPTION' &&
        auto_edit_field_value &&
        auto_edit_field_value_scope !== 'NONE') {
        message = i18n.t('workspace.taskCenter.labelingTaskTip');
    }
    if (has_delete_layer_center_task) {
        message = i18n.t('workspace.taskCenter.LayerTreeChangeTaskTip');
    }
    return message;
}
